import NutrorService from './services';
import NutrorCourseTypes from './types';

export const listNutrorCourses = () => NutrorCourseTypes.list.createAction(() => NutrorService.listNutrorCourses());
export const uploadNutrorCourses = (idProduct: number, idCourse: number, course: string, type: string) =>
  NutrorCourseTypes.upload.createAction(() => NutrorService.uploadNutrorCourses(idProduct, idCourse, course, type));
